import * as z from "zod";

export const PickUpSettingsSchema = z.object({
  incrementsOf: z.coerce.number().default(15),
  noSoonerThan: z.coerce.number().default(15),
  noLaterThan: z.coerce.number().default(60),
  allowAsap: z.boolean().default(true),
  allowArbitraryTime: z
    .union([z.literal("enabled"), z.literal("disabled")])
    .optional()
    .default("disabled"),
  status: z.union([z.literal("enabled"), z.literal("disabled")]),
});

export type PickUpSettings = z.infer<typeof PickUpSettingsSchema>;
